export default __webpack_public_path__ + "static/media/Space_tourism.3795d990.png";